import {defaultVal, isMeaningless} from "@/utils/common";

export const fbaShipmentAddressMixin = {
  data() {
    return {
      shipment: {},
    }
  },
  computed: {
    shipFromAddress() {
      const item = this.shipment.shipFromAddress;
      if (isMeaningless(item)) { return '-'; }
      return `${item.name}--${this.nullTo(item.countryCode)} ${this.nullTo(item.stateOrProvinceCode)} ${this.nullTo(item.city)} ${this.nullTo(item.addressLine1)} ${this.nullTo(item.postalCode)}`;
    },
    shipToAddress() {
      const item = this.shipment.shipToAddress;
      if (isMeaningless(item)) { return '-'; }
      return `${item.name}--${this.nullTo(item.countryCode)} ${this.nullTo(item.stateOrProvinceCode)} ${this.nullTo(item.city)} ${this.nullTo(item.addressLine1)} ${this.nullTo(item.postalCode)}`;
    },
  },
  methods: {
    nullTo(str) {
      return defaultVal(str, '');
    },
  }
};
